import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsInPlayEventsWidget" */ './SportsInPlayEventsWidget'),
  modules: ['./SportsInPlayEventsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
